export const testMock = {
  trending: {
    tokens: [
      // Start of Selection
      {
        id: "1",
        name: "Gway",
        symbol: "GWAY",
        price: "522665 USD",
        priceChange: 24.67,
        gatewayScore: 9.75,
        icon: "https://mygateway.io/favicon.svg",
      },
      {
        id: "2",
        name: "Polytrade",
        symbol: "TRADE",
        price: "52665 USD",
        priceChange: -13.04,
        gatewayScore: 9.21,
        icon: "https://mygateway.io/favicon.svg",
      },
      {
        id: "3",
        name: "Polytrade",
        symbol: "TRADE",
        price: "52665 USD",
        priceChange: 11.67,
        gatewayScore: 8.45,
        icon: "https://mygateway.io/favicon.svg",
      },
      {
        id: "4",
        name: "Polytrade",
        symbol: "TRADE",
        price: "52665 USD",
        priceChange: -5.04,
        gatewayScore: 8.21,
        icon: "https://mygateway.io/favicon.svg",
      },
      {
        id: "5",
        name: "Polytrade",
        symbol: "TRADE",
        price: "52665 USD",
        priceChange: 3.67,
        gatewayScore: 7.85,
        icon: "https://mygateway.io/favicon.svg",
      },
      {
        id: "6",
        name: "TokenX",
        symbol: "TKX",
        price: "1200 USD",
        priceChange: 15.25,
        gatewayScore: 8.9,
        icon: "https://mygateway.io/favicon.svg",
      },
      {
        id: "7",
        name: "CryptoY",
        symbol: "CRY",
        price: "320 USD",
        priceChange: -7.85,
        gatewayScore: 7.5,
        icon: "https://mygateway.io/favicon.svg",
      },
      {
        id: "8",
        name: "BlockZ",
        symbol: "BLZ",
        price: "980 USD",
        priceChange: 5.5,
        gatewayScore: 8.2,
        icon: "https://mygateway.io/favicon.svg",
      },
      {
        id: "9",
        name: "DeFiA",
        symbol: "DEFA",
        price: "450 USD",
        priceChange: -2.3,
        gatewayScore: 7.95,
        icon: "https://mygateway.io/favicon.svg",
      },
      {
        id: "10",
        name: "ChainB",
        symbol: "CHB",
        price: "760 USD",
        priceChange: 9.1,
        gatewayScore: 8.6,
        icon: "https://mygateway.io/favicon.svg",
      },
    ],
  },
};

export const events = [
  {
    date: new Date(2024, 0, 23),
    name: "Initial Jobless Claims",
    changeDirection: "unknown",
    tokens: [],
    description:
      "Weekly unemployment benefits claims report - labor market health indicator",
  },
  {
    date: new Date(2024, 0, 24),
    name: "S&P Global Composite Flash PMI",
    changeDirection: "unknown",
    tokens: [],
    description:
      "Economic activity indicator across manufacturing and services (>50 expansion, <50 contraction)",
  },
  {
    date: new Date(2024, 0, 24),
    name: "Existing Home Sales",
    changeDirection: "unknown",
    tokens: [],
    description:
      "Monthly pre-owned homes sales - housing market strength indicator",
  },
  {
    date: new Date(2024, 0, 29),
    name: "Fed Funds Target Rate",
    changeDirection: "unknown",
    tokens: [],
    description: "Federal Reserve interest rate decision",
  },
  {
    date: new Date(2024, 0, 30),
    name: "Initial Jobless Claims",
    changeDirection: "unknown",
    tokens: [],
    description: "Weekly unemployment benefits claims report",
  },
  {
    date: new Date(2024, 1, 3),
    name: "ISM Manufacturing PMI",
    changeDirection: "unknown",
    tokens: [],
    description: "Manufacturing sector health indicator (>50 expansion)",
  },
  {
    date: new Date(2024, 1, 4),
    name: "JOLTS Job Openings",
    changeDirection: "unknown",
    tokens: [],
    description: "Job vacancies and labor market conditions report",
  },
  {
    date: new Date(2024, 1, 5),
    name: "ADP National Employment Report",
    changeDirection: "unknown",
    tokens: [],
    description: "Monthly private-sector employment report",
  },
  {
    date: new Date(2024, 1, 5),
    name: "S&P Global Composite Final PMI",
    changeDirection: "unknown",
    tokens: [],
    description:
      "Final reading of economic activity in manufacturing and services",
  },
  {
    date: new Date(2024, 1, 5),
    name: "ISM Non-Manufacturing PMI",
    changeDirection: "unknown",
    tokens: [],
    description: "Service sector health indicator",
  },
  {
    date: new Date(2024, 1, 6),
    name: "Initial Jobless Claims",
    changeDirection: "unknown",
    tokens: [],
    description: "Weekly unemployment benefits claims report",
  },
];
